import Vue from 'vue'
import Router from 'vue-router'
Router.prototype.animate = 0;
Vue.use(Router);
import routes from "./routers";
import { Cookie, Local } from '../util/storage'

const router = new Router({
	routes
});


/**
 *  路由检测 拦截未登录
 */
router.beforeEach((to, from, next) => {

// requireAuth 路由 限制必须登录才能浏览
if (to.matched.some(r => r.meta.requireAuth)) {
	console.log(Local.get('isLogin'))
    if (Local.get('isLogin')) {
      next();
    }
    else {
      next({
       path: '/login',
       query: {redirect:  to.fullPath}
     })
    }
}
else {
    next();
}
})

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js